/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const refreshFromPfResponseSettingsLastSyncedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const refreshFromPfResponseSettingsLocationsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const refreshFromPfResponseSettingsLocationsItemPfHoursOneItemEndRegExp = new RegExp(
  '^([01]\\d|2[0-3]):[0-5]\\d$|^24:00$',
)
export const refreshFromPfResponseSettingsLocationsItemPfHoursOneItemStartRegExp = new RegExp(
  '^([01]\\d|2[0-3]):[0-5]\\d$|^24:00$',
)
export const refreshFromPfResponseSettingsLocationsItemPfHoursOneItemWeekdayMin = 0
export const refreshFromPfResponseSettingsLocationsItemPfHoursOneItemWeekdayMax = 6

export const refreshFromPfResponseSettingsPfMessagesContactsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const refreshFromPfResponseSettingsProfileHolidaysItemDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$')
export const refreshFromPfResponseSettingsProfileHolidaysItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const refreshFromPfResponseSettingsProfileHolidaysItemLocationIdsOneItemRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const refreshFromPfResponseSettingsProfileHoursItemEndRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$|^24:00$')
export const refreshFromPfResponseSettingsProfileHoursItemStartRegExp = new RegExp(
  '^([01]\\d|2[0-3]):[0-5]\\d$|^24:00$',
)
export const refreshFromPfResponseSettingsProfileHoursItemWeekdayMin = 0
export const refreshFromPfResponseSettingsProfileHoursItemWeekdayMax = 6

export const refreshFromPfResponseSettingsProvidersItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const refreshFromPfResponseSettingsRulesDefaultVisitTypeIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const refreshFromPfResponseSettingsUpdatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const refreshFromPfResponseSettingsUpdatedByOneUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const refreshFromPfResponseSettingsVersionMax = 9007199254740991

export const refreshFromPfResponseSettingsVisitTypesItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const refreshFromPfResponseSettingsVisitTypesItemPfDurationMinutesOneMin = -9007199254740991
export const refreshFromPfResponseSettingsVisitTypesItemPfDurationMinutesOneMax = 9007199254740991

export const refreshFromPfResponseSettingsVisitTypesItemProviderIdsOneItemRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const refreshFromPfResponseSummaryAddedContactsMin = 0
export const refreshFromPfResponseSummaryAddedContactsMax = 9007199254740991

export const refreshFromPfResponseSummaryAddedLocationsMin = 0
export const refreshFromPfResponseSummaryAddedLocationsMax = 9007199254740991

export const refreshFromPfResponseSummaryAddedProvidersMin = 0
export const refreshFromPfResponseSummaryAddedProvidersMax = 9007199254740991

export const refreshFromPfResponseSummaryAddedVisitTypesMin = 0
export const refreshFromPfResponseSummaryAddedVisitTypesMax = 9007199254740991

export const refreshFromPfResponseSummaryRemovedContactsMin = 0
export const refreshFromPfResponseSummaryRemovedContactsMax = 9007199254740991

export const refreshFromPfResponseSummaryRemovedLocationsMin = 0
export const refreshFromPfResponseSummaryRemovedLocationsMax = 9007199254740991

export const refreshFromPfResponseSummaryRemovedProvidersMin = 0
export const refreshFromPfResponseSummaryRemovedProvidersMax = 9007199254740991

export const refreshFromPfResponseSummaryRemovedVisitTypesMin = 0
export const refreshFromPfResponseSummaryRemovedVisitTypesMax = 9007199254740991

export const refreshFromPfResponseSummaryTotalAddedMin = 0
export const refreshFromPfResponseSummaryTotalAddedMax = 9007199254740991

export const refreshFromPfResponseSummaryTotalRemovedMin = 0
export const refreshFromPfResponseSummaryTotalRemovedMax = 9007199254740991

export const RefreshFromPfResponse = zod.object({
  settings: zod.object({
    coverageOptions: zod.array(
      zod.object({
        code: zod.string(),
        name: zod.string(),
      }),
    ),
    lastSyncedAt: zod.union([
      zod.iso.datetime({ offset: true }).regex(refreshFromPfResponseSettingsLastSyncedAtOneRegExp),
      zod.null(),
    ]),
    locations: zod.array(
      zod.object({
        address: zod.string(),
        id: zod.uuid().regex(refreshFromPfResponseSettingsLocationsItemIdRegExp),
        isNew: zod.boolean(),
        name: zod.string(),
        pfHours: zod.union([
          zod.array(
            zod.object({
              end: zod.string().regex(refreshFromPfResponseSettingsLocationsItemPfHoursOneItemEndRegExp),
              open: zod.boolean(),
              start: zod.string().regex(refreshFromPfResponseSettingsLocationsItemPfHoursOneItemStartRegExp),
              weekday: zod
                .int()
                .min(refreshFromPfResponseSettingsLocationsItemPfHoursOneItemWeekdayMin)
                .max(refreshFromPfResponseSettingsLocationsItemPfHoursOneItemWeekdayMax),
            }),
          ),
          zod.null(),
        ]),
        pfId: zod.string(),
        removedInPf: zod.boolean(),
        visible: zod.boolean(),
      }),
    ),
    pfMessages: zod.object({
      body: zod.string().nullable(),
      conflictLine: zod.string().nullable(),
      contacts: zod.array(
        zod.object({
          id: zod.uuid().regex(refreshFromPfResponseSettingsPfMessagesContactsItemIdRegExp),
          isNew: zod.boolean(),
          isRecipient: zod.boolean(),
          name: zod.string(),
          removedInPf: zod.boolean(),
        }),
      ),
      defaults: zod.object({
        body: zod.string(),
        conflictLine: zod.string(),
        subject: zod.string(),
      }),
      enabled: zod.boolean(),
      subject: zod.string().nullable(),
    }),
    profile: zod.object({
      contact: zod.object({
        address: zod.string(),
        email: zod.string(),
        phone: zod.string(),
      }),
      holidays: zod.array(
        zod.object({
          date: zod.string().regex(refreshFromPfResponseSettingsProfileHolidaysItemDateRegExp),
          id: zod.uuid().regex(refreshFromPfResponseSettingsProfileHolidaysItemIdRegExp),
          locationIds: zod.union([
            zod.array(zod.uuid().regex(refreshFromPfResponseSettingsProfileHolidaysItemLocationIdsOneItemRegExp)),
            zod.null(),
          ]),
          name: zod.string(),
        }),
      ),
      hours: zod.array(
        zod.object({
          end: zod.string().regex(refreshFromPfResponseSettingsProfileHoursItemEndRegExp),
          open: zod.boolean(),
          start: zod.string().regex(refreshFromPfResponseSettingsProfileHoursItemStartRegExp),
          weekday: zod
            .int()
            .min(refreshFromPfResponseSettingsProfileHoursItemWeekdayMin)
            .max(refreshFromPfResponseSettingsProfileHoursItemWeekdayMax),
        }),
      ),
    }),
    providers: zod.array(
      zod.object({
        bio: zod.string(),
        color: zod.string(),
        credentials: zod.string(),
        id: zod.uuid().regex(refreshFromPfResponseSettingsProvidersItemIdRegExp),
        isNew: zod.boolean(),
        name: zod.string(),
        pfId: zod.string(),
        removedInPf: zod.boolean(),
        specialty: zod.string(),
        visible: zod.boolean(),
      }),
    ),
    reasonMaxLength: zod.literal(500),
    rules: zod.object({
      bookingWindowDays: zod.union([
        zod.literal(14),
        zod.literal(30),
        zod.literal(45),
        zod.literal(60),
        zod.literal(90),
      ]),
      coverageCode: zod.string(),
      defaultDurationMinutes: zod.union([
        zod.literal(15),
        zod.literal(20),
        zod.literal(30),
        zod.literal(45),
        zod.literal(60),
      ]),
      defaultVisitTypeId: zod.union([
        zod.uuid().regex(refreshFromPfResponseSettingsRulesDefaultVisitTypeIdOneRegExp),
        zod.null(),
      ]),
      minNoticeHours: zod.union([
        zod.literal(0),
        zod.literal(1),
        zod.literal(2),
        zod.literal(4),
        zod.literal(24),
        zod.literal(48),
      ]),
      visitReasons: zod.array(zod.string()),
    }),
    testingIgnorePfHours: zod.boolean(),
    updatedAt: zod.iso.datetime({ offset: true }).regex(refreshFromPfResponseSettingsUpdatedAtRegExp),
    updatedBy: zod.union([
      zod.object({
        name: zod.string(),
        userId: zod.uuid().regex(refreshFromPfResponseSettingsUpdatedByOneUserIdRegExp),
        viaImpersonation: zod.boolean(),
      }),
      zod.null(),
    ]),
    version: zod.int().min(1).max(refreshFromPfResponseSettingsVersionMax),
    visitTypes: zod.array(
      zod.object({
        durationOverrideMinutes: zod.union([
          zod.union([
            zod.literal(15),
            zod.literal(20),
            zod.literal(30),
            zod.literal(45),
            zod.literal(60),
            zod.literal(90),
          ]),
          zod.null(),
        ]),
        enabled: zod.boolean(),
        id: zod.uuid().regex(refreshFromPfResponseSettingsVisitTypesItemIdRegExp),
        isNew: zod.boolean(),
        name: zod.string(),
        pfDurationMinutes: zod.union([
          zod
            .int()
            .min(refreshFromPfResponseSettingsVisitTypesItemPfDurationMinutesOneMin)
            .max(refreshFromPfResponseSettingsVisitTypesItemPfDurationMinutesOneMax),
          zod.null(),
        ]),
        pfId: zod.string(),
        providerIds: zod.union([
          zod.array(zod.uuid().regex(refreshFromPfResponseSettingsVisitTypesItemProviderIdsOneItemRegExp)),
          zod.null(),
        ]),
        removedInPf: zod.boolean(),
        telehealth: zod.boolean(),
      }),
    ),
  }),
  summary: zod.object({
    added: zod.object({
      contacts: zod
        .int()
        .min(refreshFromPfResponseSummaryAddedContactsMin)
        .max(refreshFromPfResponseSummaryAddedContactsMax)
        .optional(),
      locations: zod
        .int()
        .min(refreshFromPfResponseSummaryAddedLocationsMin)
        .max(refreshFromPfResponseSummaryAddedLocationsMax),
      providers: zod
        .int()
        .min(refreshFromPfResponseSummaryAddedProvidersMin)
        .max(refreshFromPfResponseSummaryAddedProvidersMax),
      visitTypes: zod
        .int()
        .min(refreshFromPfResponseSummaryAddedVisitTypesMin)
        .max(refreshFromPfResponseSummaryAddedVisitTypesMax),
    }),
    coverageCodeMissing: zod.boolean(),
    removed: zod.object({
      contacts: zod
        .int()
        .min(refreshFromPfResponseSummaryRemovedContactsMin)
        .max(refreshFromPfResponseSummaryRemovedContactsMax)
        .optional(),
      locations: zod
        .int()
        .min(refreshFromPfResponseSummaryRemovedLocationsMin)
        .max(refreshFromPfResponseSummaryRemovedLocationsMax),
      providers: zod
        .int()
        .min(refreshFromPfResponseSummaryRemovedProvidersMin)
        .max(refreshFromPfResponseSummaryRemovedProvidersMax),
      visitTypes: zod
        .int()
        .min(refreshFromPfResponseSummaryRemovedVisitTypesMin)
        .max(refreshFromPfResponseSummaryRemovedVisitTypesMax),
    }),
    totalAdded: zod.int().min(refreshFromPfResponseSummaryTotalAddedMin).max(refreshFromPfResponseSummaryTotalAddedMax),
    totalRemoved: zod
      .int()
      .min(refreshFromPfResponseSummaryTotalRemovedMin)
      .max(refreshFromPfResponseSummaryTotalRemovedMax),
  }),
})

export type RefreshFromPfResponse = zod.input<typeof RefreshFromPfResponse>
export type RefreshFromPfResponseOutput = zod.output<typeof RefreshFromPfResponse>
